export const MemberRole = {
  READER: 'reader',
  CONTRIBUTOR: 'contributor',
  EDITOR: 'editor',
  ADMIN: 'admin',
}

export const ROLES = [MemberRole.READER, MemberRole.CONTRIBUTOR, MemberRole.EDITOR, MemberRole.ADMIN]

export const DEFAULT_MEMBER_ROLE = MemberRole.CONTRIBUTOR

export const ROLE_HIERARCHY = {
  [MemberRole.READER]: 0,
  [MemberRole.CONTRIBUTOR]: 1,
  [MemberRole.EDITOR]: 2,
  [MemberRole.ADMIN]: 3,
}

export function roleAtLeast(role, minimum) {
  return (ROLE_HIERARCHY[role] ?? 0) >= ROLE_HIERARCHY[minimum]
}

// Roles available for invitation (no admin — must be promoted after joining)
export const INVITABLE_ROLES = [MemberRole.READER, MemberRole.CONTRIBUTOR, MemberRole.EDITOR]

// Roles available for public share links — editor is excluded; editors must be invited by email
export const SHAREABLE_LINK_ROLES = [MemberRole.READER, MemberRole.CONTRIBUTOR]

/**
 * Resolve the effective member role for a collection.
 * Sub-collection members inherit their role from the root collection.
 *
 * @param {Object} collection - Collection object (with `parent` and `members` fields)
 * @param {string} userId - Current user ID
 * @param {Function} queryCollectionWithMembers - Function to look up a collection with members loaded (e.g. VuexORM query with .with('members'))
 * @returns {string|null} The effective role
 */
export function resolveCollectionMemberRole(collection, userId, queryCollectionWithMembers) {
  if (!collection || !userId) return null

  // For root collections, use the direct membership role
  const directMember = collection.members?.find(m => m.userId === userId)

  if (!collection.parent || collection.parent === 'null') {
    return directMember?.role ?? null
  }

  // For sub-collections, resolve role from the parent/root collection
  const parentCollection = queryCollectionWithMembers?.(collection.parent)
  if (parentCollection) {
    const parentMember = parentCollection.members?.find(m => m.userId === userId)
    if (parentMember?.role) return parentMember.role
  }

  // Fallback: if parent not loaded, use direct membership (may be schema default)
  return directMember?.role ?? null
}
